'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'video-slash';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f4e2';
var svgPathData = 'M630.8 469.1l-182.8-143.3L448 199.8l112-51.33V344c0 13.25 10.75 24 24 24S608 357.3 608 344V136c0-13.69-6.875-26.27-18.39-33.67c-11.53-7.406-25.88-8.391-38.28-2.688L448 147V128c0-35.35-28.65-64-64-64L113.9 63.1L38.81 5.111C28.35-3.061 13.32-1.249 5.121 9.189C-3.051 19.63-1.233 34.72 9.189 42.89l591.1 463.1C605.6 510.3 610.8 512 615.1 512c7.125 0 14.16-3.161 18.9-9.193C643.1 492.4 641.2 477.3 630.8 469.1zM400 288.2L175.2 112H384c8.836 0 16 7.162 16 16V288.2zM384 400H96c-8.822 0-16-7.178-16-16V158.9L32.63 121.8C32.42 123.9 32 125.9 32 128v256c0 35.35 28.65 64 64 64h288c16.68 0 31.74-6.537 43.13-16.99l-40.29-31.58C385.9 399.6 385 400 384 400z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faVideoSlash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;